var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGlobalization(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1195_7413)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1195_7413",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 49
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.909184H48V48.9092H0V0.909184Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1195_7413)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.5937 24.9092C46.5937 37.3874 36.4782 47.5029 24 47.5029C11.5218 47.5029 1.40625 37.3874 1.40625 24.9092C1.40625 12.431 11.5218 2.31543 24 2.31543C36.4782 2.31543 46.5937 12.431 46.5937 24.9092Z",
    stroke: "#0049A3",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 47.5029C17.7609 47.5029 12.7031 37.3874 12.7031 24.9092C12.7031 12.431 17.7609 2.31543 24 2.31543",
    stroke: "#0049A3",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 2.31543C30.2391 2.31543 35.2969 12.431 35.2969 24.9092C35.2969 37.3874 30.2391 47.5029 24 47.5029",
    stroke: "#0049A3",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 2.31543V47.5029",
    stroke: "#0049A3",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.40625 24.9092H46.5937",
    stroke: "#0049A3",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6357 10.7851C37.4951 13.3668 31.1336 15.0198 23.9999 15.0198C16.8663 15.0198 10.5049 13.3668 6.36426 10.7851",
    stroke: "#0049A3",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.36426 39.0334C10.5049 36.4518 16.8664 34.7988 24 34.7988C31.1337 34.7988 37.4951 36.4518 41.6357 39.0334",
    stroke: "#0049A3",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1195_7413"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0 0.90918)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobalization);
export default __webpack_public_path__ + "static/media/globalization.5cd8587014e1be975ed434b96189cb6a.svg";
export { ForwardRef as ReactComponent };